import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  ValidatedFixedPanel,
  getPanelErrorProps,
  TextTitle,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import {
  ServerValidatedRemainingCharsValidatedTextField,
  GroupInfoImg,
} from '@bingads-webui-campaign-react/perf-max-step-wizard';
import { AssetGroup } from '@bingads-webui/campaign-odata-schemas';
import { StoreAppSelector } from '@bingads-webui-campaign-react/app-store-selector';
import { CampaignValidationGroup } from '@bingads-webui-campaign-react/unified-app-shared';
import { flowToPlatform } from '../model/constants';

export const AssetGroupNameSection = (props) => {
  const {
    flow, i18n, isValidating, onDataChange, campaign,
  } = props;

  const onRenderAdGroupNameLabel = useCallback(() => (
    <TextTitle titleKey={_TL_('Asset group name')} topicKey="pop_BA_Apps_AssetGroup" />
  ), []);

  return (
    <ValidatedFixedPanel
      title={<TextTitle
        titleKey={_TL_('Asset group information')}
        icon={GroupInfoImg}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      {...props}
    >
      <div>{campaign && !campaign.AppSetting && i18n.getString(_TL_('Choose the app you want to promote'))}</div>
      <CampaignValidationGroup
        data={campaign}
        onDataChange={onDataChange}
        isValidating={isValidating}
        i18n={i18n}
      >
        <StoreAppSelector
          platform={flowToPlatform[flow]}
          value={campaign && campaign.AppSetting}
          isMounted={isValidating}
          placeholderText={_TL_('Search by app name, app ID, or company')}
          readOnly={campaign && campaign.AppSettingReadOnly}
          isCountryRefinementEnabled={flowToPlatform[flow] !== 'windows'}
        />
      </CampaignValidationGroup>
      <ServerValidatedRemainingCharsValidatedTextField
        placeholder={i18n.getString(_TL_('Enter your asset group name'))}
        id="input-asset-group-name"
        validationProps={{
          field: 'Name',
          schema: AssetGroup,
        }}
        i18n={i18n}
        label={i18n.getString(_TL_('Asset group name'))}
        onRenderLabel={onRenderAdGroupNameLabel}
      />
    </ValidatedFixedPanel>
  );
};

AssetGroupNameSection.propTypes = {
  flow: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isValidating: PropTypes.bool.isRequired,
  onDataChange: PropTypes.func.isRequired,
  campaign: PropTypes.shape({
    AppSetting: PropTypes.shape({}),
    AppSettingReadOnly: PropTypes.bool,
  }).isRequired,
};
